import {
  Page,
  SkeletonView,
  VStack,
  Text,
  View,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { FlatList } from "react-native";
import { ProductPreview } from "../ProductPreview";
import { MediaCard } from "../MediaCard";
import { useItemSizing } from "../../../../utilities/photo-image/utils";
import { LoadingImageTile } from "../LoadingImageTile";

export interface ProductImageDetailsSkeletonProps {}

export function ProductImageDetailsSkeleton(
  props: ProductImageDetailsSkeletonProps
) {
  const { spacings } = useThemeProvider();

  const { imageSize, numColumns } = useItemSizing();

  const margin = spacings.s3;

  return (
    <Page cover scrollable={false}>
      <VStack fill>
        <ProductPreview loading={true} />
        <VStack fill spacing={spacings.s2}>
          <MediaCard
            titleMarkup={
              <Text variant="heading2" fontWeight="medium">
                Media
              </Text>
            }
          >
            <FlatList
              data={Array.from({ length: 5 }).map(
                (_: any, index: number) => index
              )}
              scrollEnabled={false}
              keyExtractor={(_, index) => index.toString()}
              style={{ marginLeft: -margin }}
              numColumns={numColumns}
              renderItem={() => {
                return (
                  <LoadingImageTile
                    width={imageSize}
                    height={imageSize}
                    margin={margin}
                  />
                );
              }}
            />
          </MediaCard>
        </VStack>
      </VStack>
    </Page>
  );
}
